import axios from "axios";
const setAuthToken = token => {
  if (token) {
    // Apply authorization token to every request if logged in
    axios.defaults.headers.common["authorization"] = `Bearer ${token}`;
    axios.defaults.headers.common["apikey"] = process.env.REACT_APP_APIKEY;
  } else {
    // Delete auth header
    delete axios.defaults.headers.common["authorization"];
  }
};
export default setAuthToken;